module.exports = __webpack_public_path__ + "oil-rig.5cd8f0a47e32368c4abc.jpg";


//////////////////
// WEBPACK FOOTER
// C:/dev/website2/peakai_website/peak_ai/src/assets/images/oil-rig.jpg
// module id = ../../../../../src/assets/images/oil-rig.jpg
// module chunks = styles